export default __webpack_public_path__ + "static/mockups-64d4a5b57eab9b8180071c930e8cffbb.png";